const INFO = {
	main: {
		title: "Daniel Rosenthal Game Developer",
		name: "Daniel Rosenthal",
		email: "djrosenthal004@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		phone: "(516) - 427 - 0577",
		email: "djrosenthal004@gmail.com",
		itch: "https://sirdj27.itch.io/",
		github: "https://github.com/djrosenthal27",
		linkedin: "https://www.linkedin.com/in/daniel-rosenthal-game-dev/"
	},

	homepage: {
		title: "Hi, I'm Daniel Rosenthal!",
		description:
			"I’m a junior at Northeastern University studying Computer Science and Game " +
			"Development. In addition to developing games with Unity, I have experience in web and software development," +
			" mostly with academic and practical applications towards games. My passion for creative uses of " +
			"computer science stems from my love of taking on complex challenges that require critical-thinking and" +
			" problem-solving, as well as my understanding of the potential for self-expression through digital mediums.\n\n"
		+ "I have a vast range of interests and a natural disposition for learning, whether it be for expanding my" +
			" skill set or exploring new subjects and concepts. When I’m not coding, I  " +
			"play the drum set for several groups at Northeastern, including the Northeastern Pep Band."
	},

	about: {
		title: "",
		description:
			"",
	},

	articles: {
		title: "",
		description:
			"",
	},

	projects: [
		{
			title: "Project 1",
			description:
				"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "Project 2",
			description:
				"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "Project 3",
			description:
				"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/html/html.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "Project 4",
			description:
				"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "Project 5",
			description:
				"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com",
		},
	],
};

export default INFO;
